/**
 * 保存系 API の履歴登録結果から、画面に出す警告文を決める純粋関数 (マスタ変更履歴 SBI 8)。
 *
 * - `historyRecordSucceeded === false` のときだけ警告する。
 *   `true` と未定義 (履歴項目を返さない旧バージョンの API) では警告しない。
 * - 複数回の API 呼び出しをまとめて渡せる (放送地点の一括削除・インポートなど)。
 *   1 件でも失敗があれば警告する。
 * - 失敗件数は、一括系 (`historyFailedCount` を返す API / 複数回の呼び出し) のときだけ併記する。
 *   単発の保存 (件数が自明で `historyFailedCount` も無い) には付けない。
 */
import type { HistoryRecordResult } from '../api/types';
import {
  HISTORY_RECORD_FAILED_MESSAGE,
  historyFailedCountSuffix,
} from '../constants/historyMessages';

export function buildHistoryWarning(
  results: ReadonlyArray<HistoryRecordResult | null | undefined>,
): string | null {
  let failedCount = 0;
  let anyFailed = false;
  let showCount = results.length > 1;
  for (const result of results) {
    if (!result || result.historyRecordSucceeded !== false) continue;
    anyFailed = true;
    if (typeof result.historyFailedCount === 'number') {
      showCount = true;
      failedCount += result.historyFailedCount;
    } else {
      // 件数を返さない API の失敗は、その 1 回の呼び出し = 1 件として数える
      failedCount += 1;
    }
  }
  if (!anyFailed) return null;
  return showCount
    ? `${HISTORY_RECORD_FAILED_MESSAGE}${historyFailedCountSuffix(failedCount)}`
    : HISTORY_RECORD_FAILED_MESSAGE;
}
